import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Normalize } from "styled-normalize";
import "./polyfills/EventTarget";
import App from "./App/App";
import reportWebVitals from "./reportWebVitals";
import GoogleTagManager from "./utils/googleTagManager";
import { store } from "./redux/store/store";
import { GlobalStyle } from "./globalStyles";
import "./globalStyles/style.css";
import { Metrika, YM_ID } from "./App/Metrika";
import { RefProvider } from "./contexts/RefProvider";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <>
    <Normalize />
    <GlobalStyle />
    <Provider store={store}>
      <RefProvider root={container}>
        <GoogleTagManager />
        <BrowserRouter>
          {YM_ID && <Metrika />}
          <App />
        </BrowserRouter>
      </RefProvider>
    </Provider>
  </>,
);

reportWebVitals();
